import { render, staticRenderFns } from "./traineePreassessmentReport.vue?vue&type=template&id=19b1970c&scoped=true"
import script from "./traineePreassessmentReport.vue?vue&type=script&lang=js"
export * from "./traineePreassessmentReport.vue?vue&type=script&lang=js"
import style0 from "./traineePreassessmentReport.vue?vue&type=style&index=0&id=19b1970c&prod&scoped=true&lang=css"
import style1 from "./traineePreassessmentReport.vue?vue&type=style&index=1&id=19b1970c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b1970c",
  null
  
)

export default component.exports